import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { setStorage, getStorage } from '../../../core/utilities';
import { GoogleTagService } from '../../../core/tag/google-tag.service';
import { FacebookPixelService } from '../../../core/tag/facebook-pixel.service'
import { environment } from '../../../../environments/environment';

import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

declare var UIkit: any;

@Component({
    selector: 'app-modal-permission',
    templateUrl: './modal-permission.component.html',
    styleUrls: ['./modal-permission.component.scss'],
    animations: [
        trigger('openClose', [
            // ...
            state('open', style({
                bottom: '0px',
                opacity: 1,
                visibility: 'visible'
            })),
            state('closed', style({
                bottom: '-50px',
                opacity: 0,
                visibility: 'hidden'
            })),
            transition('open => closed', [
                animate('0.3s')
            ]),
            transition('closed => open', [
                animate('0.3s')
            ]),
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ModalPermissionComponent implements OnInit {

  isAllow: Boolean = false;
  val_bool: any;

  cookie_setting: any = {
    cookie_important: {
      checked: false,
      toggle: false
    },
    cookie_performance: {
      checked: false,
      toggle: false
    },
    cookie_functional: {
      checked: false,
      toggle: false
    },
    cookie_ads: {
      checked: false,
      toggle: false
    },
  }

  constructor(
    private googleTag: GoogleTagService,
    private facebookPixel: FacebookPixelService
  ) {  

  }

  ngOnInit() {
    const cookie = this.googleTag.getCookie('cookieBannerClosed');

    if (!cookie) {
      this.initialCookie()
    } else {
      this.checkBannerClosed()
      this.checkCookieConsent()
    }

  }

  initialCookie() {
    const permission_group = { 
      necessary: 0,
      performance: 0,
      functional: 0,
      targeting: 0
    }

    const encode_text = encodeURIComponent(JSON.stringify(permission_group))
    
    this.googleTag.setCookie('cookieBannerClosed', 'false', 365)
    this.googleTag.setCookie('cookieConsent', encode_text, 365)

    this.checkCookieConsent()

    // location.reload()
  }

  checkBannerClosed() {
    const cookieBannerClosed = this.googleTag.getCookie('cookieBannerClosed');

    if (cookieBannerClosed == 'false') {
      
      setTimeout(() => {
        this.isAllow = true;
        this.val_bool = environment.cookie;
        try {
          if ((this.val_bool == 'true' || this.val_bool == true)) {
            this.isAllow = true;
          }
        } catch (err) {
          this.isAllow = true;
        }
      }, 2000);

    } else {
      this.isAllow = false
    }

  }

  checkCookieConsent() {
    const cookieConsent = this.googleTag.getCookie('cookieConsent');

    if (cookieConsent) {
      
      const { necessary, performance, functional, targeting } = JSON.parse(decodeURIComponent(cookieConsent))

      if (necessary == 1) {
        this.googleTag.setCookieConsentMode('update', {
          analytics_storage: performance == 1 ? 'granted' : 'denied',
          functionality_storage: functional == 1 ? 'granted' : 'denied',
          ad_storage: targeting == 1 ? 'granted' : 'denied',
        })
      }

      if (performance == 1) {
        this.googleTag.setGAConfiguration()
      }

      if ( functional == 1) {}

      if ( targeting == 1) {
        this.facebookPixel.setTagFacebookPixel()
      }
      
    }

  }

  updateCookie(params: object) {
    this.googleTag.setCookie('cookieBannerClosed', 'true', 365)
    this.googleTag.setCookie('cookieConsent', encodeURIComponent(JSON.stringify(params)), 365)

    this.checkBannerClosed()
    this.checkCookieConsent()
  }

  onClose(){
    this.isAllow = false;
  }

  isAllowPermission(state: boolean) {
    this.isAllow = false;

    if (state) {
      this.googleTag.setCookieGoogleAnalytic();
      setTimeout(() => {
        this.googleTag.$statePermissionTag.next('google-analytic-permission');
      }, 350)
    }

    let permission = getStorage('google-analytic-permission');
    console.log("permission: ", permission);

  }

  toggleBanner() {
    this.isAllow = !this.isAllow
  }

  toggleCookieDesc(name: string) {
    switch (name) {
      case 'cookie-important':
        this.cookie_setting.cookie_important.toggle = !this.cookie_setting.cookie_important.toggle
        break;
      case 'cookie-performance':
        this.cookie_setting.cookie_performance.toggle = !this.cookie_setting.cookie_performance.toggle
        break;
      case 'cookie-functional':
        this.cookie_setting.cookie_functional.toggle = !this.cookie_setting.cookie_functional.toggle
        break;
      case 'cookie-ads':
        this.cookie_setting.cookie_ads.toggle = !this.cookie_setting.cookie_ads.toggle
        break;
      default:
        break;
    } 
  }

  onSubmit(state?: boolean) {
    
    let cookie_setting = {}

    if (state) {

      cookie_setting = { necessary: 1, performance: 1, functional: 1, targeting: 1 }

    } else {
      
      cookie_setting = {
        necessary: 1,
        performance: this.cookie_setting.cookie_performance.checked == true ? 1: 0,
        functional: this.cookie_setting.cookie_functional.checked == true ? 1: 0,
        targeting: this.cookie_setting.cookie_ads.checked == true ? 1: 0,
      }

    }

    this.updateCookie(cookie_setting)

    UIkit.modal('#cookie-setting').hide();
  }
}

